import { render, staticRenderFns } from "./IconTitle.vue?vue&type=template&id=1c8d4649&"
import script from "./IconTitle.vue?vue&type=script&lang=js&"
export * from "./IconTitle.vue?vue&type=script&lang=js&"
import style0 from "./IconTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports